import cn from 'classnames';
import { CSSProperties, FC } from 'react';
import { isDesktop } from 'react-device-detect';
import { useSelector } from 'react-redux';
import { Typography } from 'src/components/common/Typography';
import { RootState } from 'src/types/store-types';
import './styles.scss';

type Props = {
  settings: {
    priority: number;
    styles: Styles;
    needLogin: boolean;
    classes: 'dark' | 'primary' | 'light';
  };
};
const NewsLetter: FC<Props> = ({ settings }) => {
  const { styles, classes } = settings;

  const { customI18n } = useSelector((state: RootState) => state.app);

  /*  const redirectTo = (): void => {
    const suffix = isDesktop ? 'D' : 'M';
    const url = `promotions?promo=Missão-VIP-2x-${suffix}`;
    window.open(url, '_self');
  };*/

  return customI18n?.newsLetter ? (
    <div className={cn('newsLetter_container', classes)} style={styles}>
      <div
        className="text-wrapper"
        style={{ '--start-position': isDesktop ? '100%' : '80%' } as CSSProperties}
        /*onClick={redirectTo}*/
      >
        <Typography className="text" variant={'body4'} component={'p'}>
          {customI18n?.newsLetter || 'NEWS_LETTER'}
        </Typography>
      </div>
    </div>
  ) : null;
};
export default NewsLetter;
